import { useExperimentalStyling } from '~/context/experimentalStylingContext'
import { cn } from '~/utils/tailwind-utils'

export const LabelInputContainer = ({
  label,
  children,
  isInputContainer = true,
}: {
  label: string
  children: React.ReactNode
  isInputContainer?: boolean
}) => {
  const { enableExperimentalStyling } = useExperimentalStyling()

  if (enableExperimentalStyling) {
    return (
      <div className="flex w-full flex-col space-y-2">
        <span className="text-sm font-medium text-primary">{label}</span>
        {children}
      </div>
    )
  }
  return (
    <div
      className={cn(
        'focus relative rounded-lg border border-default px-3 py-2 transition focus-within:border-emphasis',
        {
          'hover:border-emphasis': isInputContainer,
        },
      )}
    >
      <div className="text-secondary">
        <label className="text-xs font-medium">{label}</label>
      </div>
      {children}
    </div>
  )
}
